import "./Insights.module.css";
import Header from "@/reusable_sections/Header";
import LatestPropertyAdvice from "./sections/LatestPropertyAdvice";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <Header />
      <LatestPropertyAdvice />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}